import Proptypes from "prop-types";
const FileInfo = ({ fileType }) => {
  return (
    <div className="file-meta">
      <p className="meta-text"> Supported formats: PDF </p>
      <p className="meta-text">
        {fileType === "single"
          ? "Maximum file size: 20MB"
          : "You can upload up to 20 files at a time. Maximum file size per file: 20MB"}{" "}
      </p>
    </div>
  );
};

FileInfo.propTypes = {
  fileType: Proptypes.string,
};

export default FileInfo;
